import React from "react";
import { Control, Controller } from "react-hook-form";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { ControlledTextField } from "../forms/ControlledTextField";
import { GooglePlacesStreetField } from "../forms/GooglePlacesStreetField";
import { AsyncSelect } from "../forms/AsyncSelect";
import { HttpCache } from "../../http";
import { OrderDeliveryAddressFields } from "../../types/purchaseOrder/Order";
import { CHECKOUT_MAXLEN } from "../../utils/checkoutFieldMaxLengths";

interface AddressFieldsProps {
    control: Control<any>;
    baseName: string;
    showCP?: boolean;
    setValue: (name: string, value: any, options?: object) => void;
}

export const AddressFields: React.FC<AddressFieldsProps> = ({
    control,
    baseName,
    showCP = true,
    setValue,
}) => {
    const isPrivateNeighborhoodName = `${baseName}.${OrderDeliveryAddressFields.IsPrivateNeighborhood}`;

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 8 }}>
                <GooglePlacesStreetField
                    control={control}
                    name={`${baseName}.${OrderDeliveryAddressFields.Street}`}
                    baseName={baseName}
                    setValue={setValue}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <ControlledTextField
                    control={control}
                    label="Número"
                    name={`${baseName}.${OrderDeliveryAddressFields.StreetNumber}`}
                    inputProps={{ maxLength: CHECKOUT_MAXLEN.vchCalleNro }}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <ControlledTextField
                    control={control}
                    label="Piso / Departamento"
                    name={`${baseName}.${OrderDeliveryAddressFields.FloorApartment}`}
                    inputProps={{ maxLength: CHECKOUT_MAXLEN.vchPisoDpto }}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <AsyncSelect
                    label="Provincia"
                    loadOptions={HttpCache.getProvincies}
                    control={control}
                    name={`${baseName}.${OrderDeliveryAddressFields.ProvinceCode}`}
                    required
                />
            </Grid>
            <Grid size={{ xs: 12, sm: showCP ? 8 : 12 }}>
                <ControlledTextField
                    control={control}
                    label="Localidad"
                    name={`${baseName}.${OrderDeliveryAddressFields.LocalityDesc}`}
                    required
                    inputProps={{ maxLength: CHECKOUT_MAXLEN.vchDescLocalidad }}
                />
            </Grid>
            {showCP && (
                <Grid size={{ xs: 12, sm: 4 }}>
                    <ControlledTextField
                        control={control}
                        label="Código Postal"
                        name={`${baseName}.${OrderDeliveryAddressFields.ZipCode}`}
                        required
                        inputProps={{ maxLength: 10 }}
                    />
                </Grid>
            )}
            <Controller
                control={control}
                name={isPrivateNeighborhoodName}
                render={({ field }) => (
                    <>
                        <Grid size={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={Boolean(field.value)}
                                        onChange={(_, checked) => field.onChange(checked)}
                                        size="small"
                                    />
                                }
                                label="Barrio Privado"
                            />
                        </Grid>
                        {field.value && (
                            <>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <ControlledTextField
                                        control={control}
                                        label="Nombre Barrio"
                                        name={`${baseName}.${OrderDeliveryAddressFields.NeighborhoodName}`}
                                        required
                                        inputProps={{ maxLength: CHECKOUT_MAXLEN.vchNombreBarrio }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <ControlledTextField
                                        control={control}
                                        label="Lote"
                                        name={`${baseName}.${OrderDeliveryAddressFields.Lot}`}
                                        required
                                        inputProps={{ maxLength: CHECKOUT_MAXLEN.vchLote }}
                                    />
                                </Grid>
                            </>
                        )}
                    </>
                )}
            />
        </Grid>
    );
};
